/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function logDatadog(message) {
  window.DD_LOGS &&
    window.DD_LOGS.onReady(function () {
      try {
        console.log(message);
        window.DD_LOGS.logger.info(message);
      } catch (e) {
        console.log('error logging datadog in product-form.liquid');
      }
    });
}

function waitForElms(selector) {
  return new Promise((resolve) => {
    if (document.querySelectorAll(selector).length > 0) {
      return resolve(document.querySelectorAll(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelectorAll(selector).length > 0) {
        resolve(document.querySelectorAll(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// START - shogun logic to update href's with location
// given an href on the page like https://www.trxtraining.eu/collections/suspension-trainers
// and given user is on a page like https://www.trxtraining.eu/en-gb/pages/michelle-carter
// this updates hrefs on the page to be like https://www.trxtraining.eu/en-gb/collections/suspension-trainers

// We do the same update for form actions
// These comne into play on some "ADD TO CART" buttons that Shogun generates
function pathnameIsExcludedFromUpdate(pathname) {
  var pathEndWhitelist = ['sitemap.xml'];
  var isExcluded = false;
  for (var i = 0; i < pathEndWhitelist.length; i++) {
    if (pathname.endsWith(pathEndWhitelist[i])) {
      isExcluded = true;
    }
  }

  return isExcluded;
}

function handleShogunSubfolders() {
  var isShogunPage = document.getElementsByClassName('shogun-root').length > 0;
  var isHoliday2022Page = window.location.pathname.endsWith(
    '/pages/holiday-gift-guide-2022'
  );

  if (isShogunPage || isHoliday2022Page) {
    var pathname = window.location.pathname;
    var pathnameHasSubfolder = !pathname.startsWith('/pages/');
    if (pathnameHasSubfolder) {
      var splitPathname = window.location.pathname.split('/');
      if (splitPathname.length > 1) {
        var subfolder = splitPathname[1].toLowerCase();

        var anchors = document.getElementsByTagName('a');

        for (var i = 0; i < anchors.length; i++) {
          var currentAnchor = anchors[i];
          var currentHref = currentAnchor.href;
          if (currentHref) {
            try {
              var url = new URL(currentHref);
              if (url.origin === window.location.origin) {
                var urlPathname = url.pathname;
                var urlPathnameHasSubfolder = urlPathname.startsWith(
                  `/${subfolder}`
                );

                if (
                  !urlPathnameHasSubfolder &&
                  !pathnameIsExcludedFromUpdate(urlPathname)
                ) {
                  var urlPathnameWithoutLeadingSlash = urlPathname.substring(1);
                  var locationAwareUrlPathname =
                    window.Shopify.routes.root + urlPathnameWithoutLeadingSlash;
                  var newHref = url.origin + locationAwareUrlPathname;
                  currentAnchor.href = newHref;
                  logDatadog('updated shogun url', {
                    previous: currentHref,
                    new: newHref,
                  });
                }
              }
            } catch (e) {
              logDatadog('error updating shogun url');
            }
          }
        }

        var forms = document.getElementsByTagName('form');
        for (var j = 0; j < forms.length; j++) {
          var currentForm = forms[j];
          var currentAction = currentForm.action;
          if (currentAction) {
            try {
              var url = new URL(currentAction);
              if (url.origin === window.location.origin) {
                var urlPathname = url.pathname;
                var urlPathnameHasSubfolder = urlPathname.startsWith(
                  `/${subfolder}`
                );
                if (!urlPathnameHasSubfolder) {
                  var urlPathnameWithoutLeadingSlash = urlPathname.substring(1);
                  var locationAwareUrlPathname =
                    window.Shopify.routes.root + urlPathnameWithoutLeadingSlash;
                  var newAction = url.origin + locationAwareUrlPathname;
                  currentForm.action = newAction;
                  logDatadog('updated shogun action', {
                    previous: currentAction,
                    new: newAction,
                  });
                }
              }
            } catch (e) {
              logDatadog('error updating shogun action');
            }
          }
        }
      }
    }
  }
}

handleShogunSubfolders();

// END - shogun logic to update href's with location

// START - login to make sure navbar qikify links are updated
var shopifyRootHasSubfolder = window.Shopify.routes.root !== '/';
var shopifyRootSubfolder = window.Shopify.routes.root;
var subfolderWithoutSlashes = shopifyRootSubfolder.replaceAll('/', '');

function handleNavBarLinks(navBarLinks) {
  for (var k = 0; k < navBarLinks.length; k++) {
    var currentAnchor = navBarLinks[k];
    var currentHref = currentAnchor.href;
    if (currentHref) {
      try {
        var url = new URL(currentHref);
        if (url.origin === window.location.origin) {
          var urlPathname = url.pathname;
          var urlPathnameHasSubfolder = urlPathname.startsWith(
            `/${subfolderWithoutSlashes}`
          );

          if (
            !urlPathnameHasSubfolder &&
            !pathnameIsExcludedFromUpdate(urlPathname)
          ) {
            var urlPathnameWithoutLeadingSlash = urlPathname.substring(1);
            var locationAwareUrlPathname =
              window.Shopify.routes.root + urlPathnameWithoutLeadingSlash;
            var newHref = url.origin + locationAwareUrlPathname;
            currentAnchor.href = newHref;
            logDatadog('updated tmenu url', {
              previous: currentHref,
              new: newHref,
            });
          }
        }
      } catch (e) {
        logDatadog('error updating tmenu url');
        console.log({ currentAnchor, currentHref });
        console.log({ e });
      }
    }
  }
}

if (shopifyRootHasSubfolder) {
  setInterval(function () {
    waitForElms('.tmenu_links_to_localize').then(handleNavBarLinks);
    waitForElms('.tmenu_item_link').then(handleNavBarLinks);
    waitForElms('a[data-shg-product-target="product-url"]').then(
      handleShogunSubfolders
    );
  }, 1000);
}
// END - login to make sure navbar qikify links are updated

// START qikify hack to adjust prices on TTC submenu
var dcc2caa5 = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('dcc2caa5-23ca-427d-9aaf-68022ea1176f') &&
      document.getElementById('e7a879ee-a337-4a1b-8c82-d7486e570c85')
    ) {
      $('#dcc2caa5-23ca-427d-9aaf-68022ea1176f').text(function () {
        return $(this).text().replace('€', '£');
      });
      $('#e7a879ee-a337-4a1b-8c82-d7486e570c85').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(dcc2caa5);
    }
  }
}, 1000);

var af6eb982495 = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('401765ee-df70-42ca-9e69-78860d9df0f1') &&
      document.getElementById('8a63c371-8053-4067-9341-9af6eb982495')
    ) {
      $('#401765ee-df70-42ca-9e69-78860d9df0f1').text(function () {
        return $(this).text().replace('€', '£');
      });
      $('#8a63c371-8053-4067-9341-9af6eb982495').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(af6eb982495);
    }
  }
}, 1000);

var qikifyDesktopStraps = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('5b295c82-1d3e-403f-8bad-832d43bfcdf5') &&
      document.getElementById('df4c1863-9049-4f61-a327-5abc64c0c8b8')
    ) {
      $('#5b295c82-1d3e-403f-8bad-832d43bfcdf5').text(function () {
        return $(this).text().replace('€', '£');
      });
      $('#df4c1863-9049-4f61-a327-5abc64c0c8b8').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(qikifyDesktopStraps);
    }
  }
}, 1000);

var qikifyMobileStraps = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('5b9fabd3-3214-46b8-a581-72ebed6cd56f') &&
      document.getElementById('5049a556-3036-41eb-aaf3-41e1d9bc4a2c')
    ) {
      $('#5b9fabd3-3214-46b8-a581-72ebed6cd56f').text(function () {
        return $(this).text().replace('€', '£');
      });
      $('#5049a556-3036-41eb-aaf3-41e1d9bc4a2c').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(qikifyMobileStraps);
    }
  }
}, 1000);

var qikifyDesktopResistance = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('5f68c5b6-b101-4dbb-a36b-b8a11cd28db8') &&
      document.getElementById('71948f21-00c3-4fde-885a-d35092e85da3')
    ) {
      $('#5f68c5b6-b101-4dbb-a36b-b8a11cd28db8').text(function () {
        return $(this).text().replace('€69.95', '£77.00');
      });
      $('#71948f21-00c3-4fde-885a-d35092e85da3').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(qikifyDesktopResistance);
    }
  }
}, 1000);

var qikifyMobileResistance = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('fdf8e211-3445-47bc-97c5-6bac15737405') &&
      document.getElementById('8ba2eca8-727a-4329-bf18-b149ce1c3e5c')
    ) {
      $('#fdf8e211-3445-47bc-97c5-6bac15737405').text(function () {
        return $(this).text().replace('€69.95', '£77.00');
      });
      $('#8ba2eca8-727a-4329-bf18-b149ce1c3e5c').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(qikifyMobileResistance);
    }
  }
}, 1000);

var qikifyDesktopWeights = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('2d8d4839-2a9e-496c-bceb-d1f99ad7d865') &&
      document.getElementById('380ed610-c5ff-48bf-bdc4-ec6afa34838f')
    ) {
      $('#2d8d4839-2a9e-496c-bceb-d1f99ad7d865').text(function () {
        return $(this).text().replace('€', '£');
      });
      $('#380ed610-c5ff-48bf-bdc4-ec6afa34838f').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(qikifyDesktopWeights);
    }
  }
}, 1000);

var qikifyMobileWeights = setInterval(function () {
  if (window.location.pathname.toLowerCase().startsWith('/en-gb')) {
    if (
      document.getElementById('2d8d4839-2a9e-496c-bceb-d1f99ad7d865') &&
      document.getElementById('380ed610-c5ff-48bf-bdc4-ec6afa34838f')
    ) {
      $('#2d8d4839-2a9e-496c-bceb-d1f99ad7d865').text(function () {
        return $(this).text().replace('€', '£');
      });
      $('#380ed610-c5ff-48bf-bdc4-ec6afa34838f').text(function () {
        return $(this).text().replace('€', '£');
      });
      clearInterval(qikifyMobileWeights);
    }
  }
}, 1000);
// END qikify hack to adjust prices on TTC submenu

// START - custom form submission on main-customers-activate-account
$(document).ready(function () {
  var $errorContainer = $('#activate-account-error-3d5c6a1c');
  var $errorMessage = $('#activate-account-error-3d5c6a1c > .banner__content');
  var $submitButton = $('#submit-button-3d5c6a1c');

  function hideErrorContainer() {
    $errorContainer.hide();
  }

  function displayErrorContainer() {
    $errorContainer.show();
  }

  function updateErrorMessage(val) {
    $errorMessage.text(val);
  }

  hideErrorContainer();

  function validate({ customerPassword, customerPasswordConfirmation }) {
    if (customerPassword !== customerPasswordConfirmation) {
      return "Passwords don't match";
    }

    if (customerPassword.length < 6 || customerPasswordConfirmation < 6) {
      return 'Please enter at least 6 characters';
    }

    return null;
  }

  function handleSubmit() {
    $('#loading-spinner').show();

    var $customerPassword = $('#customer_password_3d5c6a1c');
    var $customerPasswordConfirmation = $(
      '#customer_password_confirmation_3d5c6a1c'
    );

    var customerPassword = $customerPassword.val();
    var customerPasswordConfirmation = $customerPasswordConfirmation.val();

    var errorMessage = validate({
      customerPassword,
      customerPasswordConfirmation,
    });
    if (errorMessage) {
      displayErrorContainer();
      updateErrorMessage(errorMessage);
      $('#loading-spinner').hide();
    } else {
      hideErrorContainer();
      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password: customerPassword,
          activation_url: window.location.href,
          is_eu: 'True',
        }),
      };

      var url =
        'https://trx-carabiner.herokuapp.com/api/v1/shopify/account/activate';

      fetch(url, requestOptions)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.access_token && data.email && data.status === true) {
            logDatadog('success handleSubmit /api/v1/shopify/account/activate');
            exchangeMultipassToken(data.access_token, data.email);
          } else {
            displayErrorContainer();
            updateErrorMessage(
              'Error activation account. Please try again or contact support@trxtraining.com'
            );
            $('#loading-spinner').hide();
            logDatadog('error handleSubmit /api/v1/shopify/account/activate');
          }
        });
    }
  }

  $submitButton.on('click', handleSubmit);
});
// END - custom form submission on main-customers-activate-account

// START - gift with purchase custom logic
function isEuSite() {
  return window.location.origin.endsWith('.eu');
}

function isUkSite() {
  return window.location.href.split('-gb/').length === 2;
}

function getGiftWithPurchaseGiftItem() {
  var currentNewYorkTimeFormatted = new Date().toLocaleString('en-US', {
    timeZone: 'America/New_York',
  });
  var currentNewYorkTimeObject = new Date(currentNewYorkTimeFormatted);

  var currentNewYorkMonth = currentNewYorkTimeObject.getMonth() + 1;
  var currentNewYorkDay = currentNewYorkTimeObject.getDate();
  var currentNewYorkYear = new Date().toLocaleString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
  });

  var giftWithPurchaseGiftItems = {
    xmount: {
      month: 10,
      dayStart: 13,
      dayEnd: 3,
      endMonth: 11,
      sku: 'TRXXMOUNT4',
      href: '/products/xmount?variant=40006818955404',
      variantId: 40006818955404,
      qualifyingAmount: 17500,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX XMount 🎁 🎁<p>"
    },
    strengthBand: {
      month: 11,
      dayStart: 13,
      dayEnd: 25,
      endMonth: 12,
      sku: 'TRX-ER-BAND-45/110',
      href: '/products/strength-bands?variant=39836005171340',
      variantId: 39836005171340,
      qualifyingAmount: 15000,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Strength Band 🎁 🎁<p>"
    }
  }
  if (isEuSite()) {
    giftWithPurchaseGiftItems = {
      strengthBand: {
        month: 11,
        dayStart: 13,
        dayEnd: 20,
        endMonth: 11,
        sku: 'TRX-ER-BAND-45/110',
        href: '/products/strength-bands?variant=40257124827225',
        variantId: 40257124827225,
        qualifyingAmount: 15000,
        freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Strength Band 🎁 🎁<p>"
      }
    }
  }

  var giftItemsKeys = Object.keys(giftWithPurchaseGiftItems);
  var matchingGiftItem;
  var today = new Date(
    currentNewYorkYear,
    currentNewYorkMonth - 1,
    currentNewYorkDay
  );

  for (var i = 0; i < giftItemsKeys.length; i++) {
    if (!matchingGiftItem) {
      var giftItemsKey = giftItemsKeys[i];
      var giftItemData = giftWithPurchaseGiftItems[giftItemsKey];
      var isMatchingGiftItem = false;

      var startDate = new Date(
        currentNewYorkYear,
        giftItemData.month - 1,
        giftItemData.dayStart
      );
      var endMonth = giftItemData.endMonth || giftItemData.month;
      var endDay = giftItemData.dayEnd || 31;
      var endDate = new Date(currentNewYorkYear, endMonth - 1, endDay);

      if (startDate <= today && today <= endDate) {
        isMatchingGiftItem = true;
      }

      if (isMatchingGiftItem) {
        matchingGiftItem = giftItemData;
      }
    }
  }

  console.log({ matchingGiftItem });
  return matchingGiftItem;
}

function cartContainsEligibleGiftWithPurchaseItem({ cartData }) {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    return false;
  }

  var cartLineItems = cartData.items;

  if (cartLineItems.length === 0) {
    return false;
  }

  var matchingPurchaseItemInCart = cartLineItems.find(function (lineItem) {
    return (
      lineItem &&
      lineItem.variant_id &&
      giftItem.purchaseVariantIds &&
      giftItem.purchaseVariantIds.includes(lineItem.variant_id)
    );
  });

  return !!matchingPurchaseItemInCart;
}

function cartContainsGiftWithPurchaseGiftItem({ cartData }) {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    return false;
  }

  var cartLineItems = cartData.items;

  if (cartLineItems.length === 0) {
    return false;
  }

  var matchingGiftItemInCart = cartLineItems.find(function (lineItem) {
    return (
      lineItem &&
      lineItem.variant_id &&
      lineItem.variant_id === giftItem.variantId
    );
  });

  return !!matchingGiftItemInCart;
}

function handleCartDataForGWP({ cartData }) {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    logDatadog('giftWithPurchase; handleCartDataForGWP; !giftItem');
    return;
  } else {
    logDatadog('giftWithPurchase; handleCartDataForGWP; giftItem');
  }

  if (cartData.items === undefined) {
    logDatadog(
      'giftWithPurchase; handleCartDataForGWP; cartData.items === undefined'
    );
    return;
  }

  var total_price = cartData.total_price;
  var _cartContainsGiftItem = cartContainsGiftWithPurchaseGiftItem({
    cartData: cartData,
  });
  var _cartContainsEligibleGiftWithPurchaseItem =
    cartContainsEligibleGiftWithPurchaseItem({ cartData: cartData });

  var $minicartContainer = $('#holiday-gwp-2022-container');
  var $maincartContainer = $('#holiday-gwp-2022-container-maincart');

  $maincartContainer.empty();
  $minicartContainer.empty();

  if (cartData.item_count) {
    console.log({
      total_price,
      _cartContainsGiftItem,
      _cartContainsEligibleGiftWithPurchaseItem,
      giftItem,
    });
    logDatadog('giftWithPurchase; handleCartDataForGWP; total_price');

    if (giftItem.qualifyingAmount) {
      var qualifyingAmountCopy = `${giftItem.qualifyingAmount}`;
      qualifyingAmountCopy = qualifyingAmountCopy.substring(
        0,
        qualifyingAmountCopy.length - 2
      );

      var isCartPage = window.location.pathname.startsWith('/cart');

      if (total_price < giftItem.qualifyingAmount) {
        logDatadog(
          'holiday2022; handleCartDataForGWP; total_price < giftItem.qualifyingAmount; start'
        );

        var copy = `<p>&#x1F381; Free gift on orders over £${qualifyingAmountCopy}. Add additional product(s) to qualify. &#x1F381;</p>`;

        if (!isCartPage) {
          waitForElm(`#holiday-gwp-2022-container`).then(function () {
            setTimeout(function () {
              var $minicartContainer = $('#holiday-gwp-2022-container');
              if ($minicartContainer.length) {
                $minicartContainer.empty();
                logDatadog(
                  'holiday2022; handleCartDataForGWP; total_price < giftItem.qualifyingAmount; $minicartContainer.length'
                );
                $minicartContainer.append(function () {
                  return $(copy).click(handleClickForGWPPlaceholderText);
                });
              }
            }, 1000);
          });
        }
        if ($maincartContainer.length) {
          logDatadog(
            'holiday2022; handleCartDataForGWP; total_price < giftItem.qualifyingAmount; $maincartContainer.length'
          );
          $maincartContainer.append(copy);
        }
      } else if (
        total_price >= giftItem.qualifyingAmount &&
        !_cartContainsGiftItem
      ) {
        logDatadog(
          'holiday2022; handleCartDataForGWP; total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem; start'
        );
        var autoAddLink = `${window.themeVariables.routes.rootUrlWithoutSlash}/cart/add?id=${giftItem.variantId}&quantity=1`;
        var handler = function () {
          handleClickForGWP({ href: autoAddLink });
        };
        var copy = giftItem.freeCartCopy;

        if (!isCartPage) {
          waitForElm(`#holiday-gwp-2022-container`).then(function () {
            setTimeout(function () {
              var $minicartContainer = $('#holiday-gwp-2022-container');
              if ($minicartContainer.length) {
                $minicartContainer.empty();
                logDatadog(
                  'holiday2022; handleCartDataForGWP; total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem; $minicartContainer.length'
                );
                $minicartContainer.append(function () {
                  return $(copy).click(handler);
                });
              }
            }, 1000);
          });
        }
        if ($maincartContainer.length) {
          logDatadog(
            'holiday2022; handleCartDataForGWP; total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem; $maincartContainer.length'
          );
          $maincartContainer.append(function () {
            return $(copy).click(handler);
          });
        }
      }
    } else if (
      _cartContainsEligibleGiftWithPurchaseItem &&
      !_cartContainsGiftItem
    ) {
      logDatadog(
        'giftWithPurchase; handleCartDataForGWP; _cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem; start'
      );
      var autoAddLink = `${window.themeVariables.routes.rootUrlWithoutSlash}/cart/add?id=${giftItem.variantId}&quantity=1`;
      var handler = function () {
        handleClickForGWP({ href: autoAddLink });
      };
      var copy = giftItem.freeCartCopy;

      if (!isCartPage) {
        waitForElm(`#holiday-gwp-2022-container`).then(function () {
          setTimeout(function () {
            var $minicartContainer = $('#holiday-gwp-2022-container');
            if ($minicartContainer.length) {
              $minicartContainer.empty();
              logDatadog(
                'giftWithPurchase; handleCartDataForGWP; _cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem; $minicartContainer.length'
              );
              $minicartContainer.append(function () {
                return $(copy).click(handler);
              });
            }
          }, 1000);
        });
      }
      if ($maincartContainer.length) {
        logDatadog(
          'giftWithPurchase; handleCartDataForGWP; _cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem; $maincartContainer.length'
        );
        $maincartContainer.append(function () {
          return $(copy).click(handler);
        });
      }
    }
  } else {
    logDatadog('giftWithPurchase; handleCartDataForGWP; !total_price');
  }
}

var loadingRedirectForGWP = false;
function handleClickForGWP({ href }) {
  if (!loadingRedirectForGWP) {
    logDatadog('holiday2022; handleClickForGWP; !loadingRedirectForGWP');
    localStorage.setItem('set2022gwpItem', true);
    window.location.href = href;
    loadingRedirectForGWP = true;
  } else {
    logDatadog('holiday2022; handleClickForGWP; loadingRedirectForGWP');
  }
}

function handleClickForGWPPlaceholderText() {
  if (isEuSite()) {
    window.location.href = `/en-gb/collections/all-products`;
  } else {
    window.location.href = `/collections/all-products`;
  }
}

$(document).ready(function () {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    logDatadog('giftWithPurchase; $(document).ready; !giftItem');
    return;
  } else {
    logDatadog('giftWithPurchase; $(document).ready; giftItem');
  }

  var set2022gwpItem = localStorage.getItem('set2022gwpItem');
  localStorage.removeItem('set2022gwpItem');
  console.log({ set2022gwpItem });
  if (set2022gwpItem === 'true') {
    logDatadog('giftWithPurchase; $(document).ready; set2022gwpItem');
    if (
      typeof startConfetti === 'function' &&
      typeof stopConfetti === 'function'
    ) {
      startConfetti();
      setTimeout(function () {
        stopConfetti();
      }, 2000);
    }
  }

  fetch(`${window.themeVariables.routes.cartUrl}.js`)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      console.log({ data });
      logDatadog('giftWithPurchase; $(document).ready; data');
      return handleCartDataForGWP({ cartData: data });
    });
})(
  // END - gift with purchase custom logic

  // START hide ATC of giftcard holiday 2022
  (function () {
    $(document).ready(function () {
      if (
        window.location.pathname.endsWith('/products/giftcard') ||
        window.location.pathname.endsWith('/products/rise-ai-giftcard')
      ) {
        $('[data-product-add-to-cart-button]').hide();
        $('.product-sticky-form').hide();
      }
    });
  })()
);

(function () {
  $(document).ready(function () {
    if (window.location.pathname.includes('/account')) {
      var count = 0;
      var intervalId = setInterval(function () {
        if (count > 25) {
          clearInterval(intervalId);
          return;
        }

        count++;

        if ($('#Rise-account-page-button').length) {
          $('#Rise-account-page-button')
            .detach()
            .prependTo('.link-bar__linklist.list--unstyled');
          clearInterval(intervalId);
          return;
        }
      }, 200);
    }
  });
})();
// END hide ATC of giftcard holiday 2022
